<template>
  <div class="spacer"></div>
</template>

<script>
export default {
  name: 'Spacer',
}
</script>

<style lang="scss" scoped>
.spacer {
  height: 40px;
}
</style>
